import React from "react";

interface TableLoadingSkeletonProps {
  rows?: number;
  columns?: number;
}

const COLUMN_WIDTHS = ["flex-1", "w-1/4", "w-1/5", "w-1/6", "w-1/4", "w-1/5"];

export default function TableLoadingSkeleton({
  rows = 5,
  columns = 4,
}: TableLoadingSkeletonProps) {
  const widths = COLUMN_WIDTHS.slice(0, columns);

  return (
    <div className="w-full space-y-2 p-2">
      {/* Header row */}
      <div className="flex gap-4 animate-pulse mb-1">
        {widths.map((w, i) => (
          <div key={i} className={`h-7 bg-gray-300 rounded ${w}`} />
        ))}
      </div>
      {/* Content rows */}
      {Array.from({ length: rows }).map((_, rowIdx) => (
        <div key={rowIdx} className="flex gap-4 animate-pulse">
          {widths.map((w, colIdx) => (
            <div
              key={colIdx}
              className={`h-6 rounded ${w}`}
              style={{
                backgroundColor: rowIdx % 2 === 0 ? "#f3f4f6" : "#e5e7eb",
                animationDelay: `${rowIdx * 60}ms`,
              }}
            />
          ))}
        </div>
      ))}
    </div>
  );
}
